
<div class="form-group">
  <label>{{title}}</label>
  <div class="input-group">
    <span class="form-control" (click)="toogleDisplay()" *ngIf="!multiple">{{selected ? selected : "Selecione "+title}}</span>
    <div class="form-control2 form-control" (click)="toogleDisplay()" *ngIf="multiple">
      <div class="row d-flex justify-content-center">
        <div class="p-2 my-1" *ngFor="let item of  selected; let i = index">
          <div class="input-group">
            <label class="input-group-text justify-content-center border-l-r-width" for="inputGroupSelect01">{{item}}</label>
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" (click)="pop(i)"><fa-icon [icon]="faTimes" class="fad fa-times textColor mine-shaft base"></fa-icon></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="input-group-append">
       <button class="btn harvest-gold base input-group-text" (click)="toogleDisplay()"><fa-icon [icon]="faChevronDown" class="fad fa-chevron-down" id="fa{{title}}"></fa-icon></button>
    </div>
  </div>
  <div class="row noMarg" *ngIf="display">
    <div class="input-group">
      <div class="input-group-prepend">
         <button class="btn harvest-gold base input-group-text"><fa-icon [icon]="faSearch" class="fad fa-search"></fa-icon></button>
      </div>
      <input class="form-control" placeholder="Procurar {{title.toLowerCase()}}" [(ngModel)]="search" (ngModelChange)="toogleSearch()">
    </div>
  </div>
  <div class="row noMarg"*ngIf="display">
    <ng-container *ngFor="let it of list; let i =index;">
      <span class="form-control select pointer" [class.darker]="i%2==0" (click)="toogleSelection(it)">{{it}}</span>
    </ng-container>
  </div>
</div>